import ComingSoon from '../components/newsletter-component'

function Newsletter() {
    return (
        <ComingSoon />
    )
}

export default Newsletter;